import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import DataTable from '../ui/table';
var t = i18n.getFixedT(null, 'logistic-deliver');

var TopTenDriver = function TopTenDriver() {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      topTenDriverList = _useSelector.logisticDeliver.topTenDriverList;

  var dispatch = useDispatch();
  var isMounted = useRef(false);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'name', {
    label: t('lbl-driver-name')
  });

  _.set(fields, 'logisticName', {
    label: t('lbl-logistic')
  });

  _.set(fields, 'avgDuration', {
    label: t('lbl-avgDuration'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "duration-div"
      }, val === -1 ? t('lbl-no-data') : val + t('lbl-minute'));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "topTenDriver-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-the-shortest-duration-driver'))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    enableTextWordWrap: true,
    fields: fields,
    data: topTenDriverList ? topTenDriverList : [] // sort={logisticsForecastSort}
    // onSort={handleSort}

  })));
};

export default TopTenDriver;